<script setup lang="ts">
import { cn } from "@/lib/utils";
import {
  TimeFieldRoot as RekaTimeFieldRoot,
  type TimeFieldRootEmits,
  type TimeFieldRootProps,
  useForwardPropsEmits,
  type SegmentPart
} from "reka-ui";
import { type HTMLAttributes, computed, provide, shallowRef } from "vue";

type Segment = { part: SegmentPart; value: string };

const props = defineProps<
  TimeFieldRootProps & { class?: HTMLAttributes["class"] }
>();
const emits = defineEmits<TimeFieldRootEmits>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);

const segments = shallowRef<Segment[]>([]);
provide("timeFieldSegments", segments);
</script>

<template>
  <RekaTimeFieldRoot  
    v-slot="{ segments: slotSegments }"
    v-bind="forwarded"
    :class="cn('flex flex-col gap-1.5', props.class)"
  >
    <slot :segments="(segments = slotSegments, slotSegments)" />
  </RekaTimeFieldRoot>
</template>
